import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CreateTagRequest, Tag } from '@ps/feature-tags';

export const TagsActions = createActionGroup({
  source: 'Tags',
  events: {
    'Load Tags': emptyProps(),
    'Create Tag': props<{ request: CreateTagRequest }>(),
  },
});

export const TagsApiActions = createActionGroup({
  source: 'Tags API',
  events: {
    'Load Tags Success': props<{ tags: Tag[] }>(),
    'Load Tags Failure': props<{ error: string }>(),
    'Create Tag Success': props<{ tag: Tag }>(),
    'Create Tag Failure': props<{ error: string }>(),
  },
});
